// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__2S_Pr","text":"LimitedAccessBanner_text__37y-Y","button":"LimitedAccessBanner_button__-gLRN"};